"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setupActivityPage = setupActivityPage;
exports.setupActivityElement = setupActivityElement;
exports.setupImageWrapStub = setupImageWrapStub;
exports.setupActivityInfoModal = setupActivityInfoModal;
exports.default = void 0;

var _decorators = require("decorators");

var _animationHelper = babelHelpers.interopRequireDefault(require("animation-helper"));

var _corePlugin = babelHelpers.interopRequireDefault(require("core-plugin"));

var _pie = require("pie");

var _promisePolyfill = babelHelpers.interopRequireDefault(require("promise-polyfill"));

var _userProfile = require("user-profile");

var Discussion = babelHelpers.interopRequireWildcard(require("components/Discussion"));

var _Listener = babelHelpers.interopRequireDefault(require("components/Notifications/Listener"));

var _fetch = babelHelpers.interopRequireDefault(require("fetch"));

var _SiteLayout = babelHelpers.interopRequireDefault(require("layouts/SiteLayout"));

var _compat = babelHelpers.interopRequireDefault(require("compat"));

var _class, _descriptor, _descriptor2, _descriptor3, _temp, _class3, _class4, _temp2;

var InvalidStateError =
/*#__PURE__*/
function (_Error) {
  babelHelpers.inherits(InvalidStateError, _Error);

  function InvalidStateError() {
    babelHelpers.classCallCheck(this, InvalidStateError);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(InvalidStateError).apply(this, arguments));
  }

  return InvalidStateError;
}(babelHelpers.wrapNativeSuper(Error));

;

function hidden(target, name, descriptor) {
  descriptor.enumerable = false;
  return descriptor;
}

var ActivityEvent = (_class = (_temp =
/*#__PURE__*/
function () {
  babelHelpers.createClass(ActivityEvent, [{
    key: "preventDefault",
    value: function preventDefault() {
      if (this.cancelable) this._cancelled = true;
    }
  }, {
    key: "stopImmediatePropagation",
    value: function stopImmediatePropagation() {
      this._stopped = 'now';
    }
  }, {
    key: "stopPropagation",
    value: function stopPropagation() {
      if (this._stopped == false) this._stopped = true;
    }
  }, {
    key: "cancelBubble",
    get: function get() {
      return this._cancelled;
    },
    set: function set(value) {
      this._cancelled = this.cancelable ? !!value || this._cancelled : false;
    }
  }, {
    key: "defaultPrevented",
    get: function get() {
      return this._cancelled;
    }
  }]);

  function ActivityEvent(type, _ref) {
    var bubbles = _ref.bubbles,
        cancelable = _ref.cancelable;
    babelHelpers.classCallCheck(this, ActivityEvent);
    this.bubbles = false;
    babelHelpers.initializerDefineProperty(this, "_cancelled", _descriptor, this);
    babelHelpers.initializerDefineProperty(this, "_stopped", _descriptor2, this);
    babelHelpers.initializerDefineProperty(this, "_dispatched", _descriptor3, this);
    this.cancelable = false;
    this.currentTarget = null;
    this.eventPhase = ActivityEvent.AT_TARGET;
    this.originalTarget = null;
    this.target = null;
    this.timeStamp = Date.now();
    this.type = null;
    this.isTrusted = false;
    this.type = type;
    this.bubbles = bubbles;
    this.cancelable = cancelable;
  }

  return ActivityEvent;
}(), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "_cancelled", [hidden], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "_stopped", [hidden], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "_dispatched", [hidden], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
})), _class);
var Activity = (_class3 = (_temp2 = _class4 =
/*#__PURE__*/
function () {
  function Activity(root, readOnly, state) {
    var _this = this;

    babelHelpers.classCallCheck(this, Activity);
    this.startButtonLabel = 'Start Now';
    this.alwaysShowCompletionBanner = false;
    this.gotActivityBody = false;
    this._gettingActivityBody = false;
    this._timerDuration = null;
    this._timerTimeout = null;
    this._timerLastTick = null;
    this._timerHidden = false;
    this._timerRunning = false;
    this._globalResize = null;
    this._rootNode = root;
    var r = this.$();
    this._isEditing = r.data('editor');
    this._channelKey = r.data('channelKey');
    this._channelID = r.data('channelId');
    this._catalogItemID = r.data('catalogItemId');
    this._courseID = r.data('courseId');
    this._activityID = r.data('activityId');
    this._gettingActivityDetail = false;
    this._activityDetail = null;
    this._events = {};
    this._readOnly = readOnly || false;
    var t = r.data('startButtonLabel');
    if (t) this.startButtonLabel = t;

    if (!this._isEditing && history.replaceState) {
      if (this.$().data('isReadOnly')) {
        history.replaceState(null, null, "".concat(this.$().data('detailLink'), "/activity/").concat(this.$().data('activityIndex'), "?view=1"));
      } else {
        history.replaceState(null, null, "".concat(this.$().data('detailLink'), "/activity/").concat(this.$().data('activityIndex')));
      }
    }

    this.$('a.navbar-back').on('click', function () {
      if (!_this._isEditing) _this.doPreviousActivity();
      return false;
    });
    this.addEventListener('showingFinishedBanner', this._showingFinishedBanner);

    if (this._isEditing) {
      this._gettingActivityDetail = true;
      this._activityDetail = state.startActivityEntry;
    }

    if (readOnly) {
      this._gettingActivityDetail = true;
      this._activityDetail = state.startActivityEntry;
      this._endActivityState = state.endActivityEntry;
      this._assignmentState = state.assignmentState;
      this._isEndingActivity = true;
      var didReady = false;

      var waitForReady = function waitForReady() {
        if (!didReady) {
          didReady = true;

          _this._showFinishedBanner();

          if (!_this.endActivityState.restartActivity) {
            _this.showNextActivityButton(_this.endActivityState.completedCourse, _this.endActivityState.restartActivity, _this.endActivityState.buttonTitle || 'Next');
          }
        }
      };

      $(waitForReady);
      setTimeout(waitForReady, 100);
    }

    this.addEventListener('activityComplete', this._activityComplete, false);
    this.addEventListener('startedActivity', this._startedActivity, false);
    this.addEventListener('startAssignment', this._startAssignment, false);
    this.$().on('click', 'a.navbar-home', function (event) {
      _this.$('.course-navigation-block').toggleClass('in');

      _this.$('.activity-header').toggleClass('course-navigation-open', _this.$('.course-navigation-block').is('.in'));

      event.preventDefault();
    });
    this.$('.activity-header').append("<div class='course-navigation-block'></div>");

    if (!this._isEditing) {
      this.loadNavigation();
      this.addEventListener('endedActivity', function () {
        _this.loadNavigation();
      });

      _Listener.default.addEventListener('courseCompleted', this._courseCompleteNotification);

      _Listener.default.addEventListener('updated-courseCompleted', this._courseCompleteNotification);

      this.addEventListener('unload', function () {
        _Listener.default.removeEventListener('courseCompleted', _this._courseCompleteNotification);

        _Listener.default.removeEventListener('updated-courseCompleted', _this._courseCompleteNotification);
      });
    }
  }

  babelHelpers.createClass(Activity, [{
    key: "_courseCompleteNotification",
    value: function _courseCompleteNotification(event) {
      if (event.data.catalogItem.id == this._catalogItemID && event.data.isNew) {
        this.courseCompleteNotificationId = event.data.id;
        event.preventDefault(); // Stop the growl banner from appearing.
      }
    }
  }, {
    key: "_activityComplete",
    value: function _activityComplete() {
      this.activityIsComplete = true;

      if (!this.alwaysShowCompletionBanner) {
        return;
      }

      this._showFinishedBanner();

      this.$().trigger('activityComplete');
    }
  }, {
    key: "_startedActivity",
    value: function _startedActivity() {
      if (!this.keepImageOverlay) {
        this.$('.media-container').removeClass('image-overlay');
      }
    }
  }, {
    key: "_startAssignment",
    value: function _startAssignment() {
      var _this2 = this;

      (0, _userProfile.getUserProfile)().then(function (_ref2) {
        var id = _ref2.id;

        if (_this2.$('.activity-body #discussionRoot').length == 0) {
          _this2.$('.activity-body').append("\n\t\t\t\t\t<div class='assignment-wrapper'>\n\t\t\t\t\t\t<div class='assignment-header'>Assignment</div>\n\t\t\t\t\t\t".concat(_this2.assignmentState.detail ? "<div class='assignment-detail'>".concat(_this2.assignmentState.detail, "</div>") : '', "\n\t\t\t\t\t\t<div id='discussionRoot'></div>\n\t\t\t\t\t</div>\n\t\t\t\t"));
        }

        var node = _this2.$('.activity-body #discussionRoot')[0];

        Discussion.showDiscussion(node, _this2.assignmentState.id, id, null, function () {
          // When a comment is posted, try ending the activity.
          _this2.endActivity();
        });

        _this2.addEventListener('unload', function () {
          Discussion.removeDiscussion(node);
        });
      });
    }
  }, {
    key: "_showingFinishedBanner",
    value: function _showingFinishedBanner() {
      var r = this.$();
      if (r.find('.activity-subheader .finished-banner').length == 0) return;
      if (r.find('.activity-subheader .finished-banner-caret').length == 0) r.find('.activity-subheader').append("<div class='finished-banner-caret' style='height: 0px; overflow: hidden;'></div>");
      setTimeout(function () {
        var c = new _animationHelper.default(500, 'ease-in-out', function (percent) {
          if (percent) r.find('.activity-subheader .finished-banner-caret').css({
            height: 'auto'
          });
          var e = r.find('.activity-subheader .finished-banner');
          var hh = e[0].scrollHeight;
          var lh = e.height();
          var hd = Math.round(percent * hh) - lh;
          e.css({
            height: percent == 1 ? 'auto' : Math.round(percent * hh)
          });
          $(document).triggerHandler('scroll');
        }, function () {
          r.find('.activity-subheader .finished-banner').css({
            height: 'auto'
          });
          $(document).triggerHandler('scroll');
        });
        c.start();
      }, 0);
    }
  }, {
    key: "hideFinishedBanner",
    value: function hideFinishedBanner() {
      var r = this.$();

      if (r.find('.activity-subheader .finished-banner').length) {
        var c = new _animationHelper.default(500, 'ease-in-out', function (percent) {
          var e = r.find('.activity-subheader .finished-banner');
          var e1 = r.find('.activity-subheader .finished-banner-caret');
          var hh = e[0].scrollHeight,
              hh1 = e1[0].scrollHeight;
          var pct = 1 - percent;
          var lh = e.height(),
              lh2 = e1.height(),
              hd = pct * hh - lh,
              hd2 = pct * hh - lh2;
          e.css({
            height: pct == 0 ? 0 : Math.round(pct * hh)
          });
          e1.css({
            height: pct == 0 ? 0 : Math.round(pct * hh1)
          });

          if (!pct) {
            r.find('.activity-subheader').find('.finished-banner, .finished-banner-caret').remove();
          }

          $(document).triggerHandler('scroll');
        }, function () {
          r.find('.activity-subheader').find('.finished-banner, .finished-banner-caret').remove();
          $(document).triggerHandler('scroll');
        });
        c.start();
      }
    }
  }, {
    key: "_showFinishedBanner",
    value: function _showFinishedBanner() {
      var r = this.$();
      r.find('.activity-subheader').find('.finished-banner, .finished-banner-caret').remove();
      var rv = this.dispatchEvent(this._event('showFinishedBanner', true));
      this.dispatchEvent(this._event('showingFinishedBanner'));
    }
  }, {
    key: "loadNavigation",
    value: function loadNavigation() {
      var _this3 = this;

      $.get(this.$().data('navigationAddress'), function (r) {
        _this3.$('.course-navigation-block').html(r);

        _this3.$('.course-navigation-block [data-pie]:not(.animated)').toArray().forEach(function (e) {
          return (0, _pie.pie)(e);
        });

        _this3.$('.course-navigation-block [data-activity-id]').on('click', function (_ref3) {
          var target = _ref3.currentTarget;

          _this3.$('.course-navigation-block').removeClass('in');

          _this3.$('.activity-header').removeClass('course-navigation-open');

          var tgtId = target.dataset.activityId;
          var tgt = target.dataset.activity;
          setTimeout(function () {
            if (_this3.$().data('activityId') != tgtId) {
              _this3.doSpecificActivity(tgt);
            }
          }, 150);
          return false;
        });

        _this3.$('.course-navigation-block .close').on('click', function () {
          _this3.$('.activity-header').removeClass('course-navigation-open');
        });
      });
    } // _events = {};

  }, {
    key: "addEventListener",
    value: function addEventListener(type, callback) {
      Activity._addEventListener(this, type, callback);
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(type, callback) {
      Activity._removeEventListener(this, type, callback);
    }
  }, {
    key: "dispatchEvent",
    value: function dispatchEvent(event) {
      return Activity._dispatchEvent(this, event);
    }
  }, {
    key: "_event",
    value: function _event(type) {
      var cancelable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var E = new ActivityEvent(type, {
        cancelable: cancelable
      });
      Object.assign(E, props || {});
      return E;
    }
  }, {
    key: "_bareReq",
    value: function _bareReq(method, path, type, data, callback) {
      (0, _fetch.default)(path, Object.assign({
        method: method,
        headers: method == 'GET' ? {} : {
          'Content-Type': type
        }
      }, method == 'GET' ? {} : {
        body: data
      })).then(function (result) {
        result.text().then(function (text) {
          callback(text);
        });
      });
    }
  }, {
    key: "_lmsReq",
    value: function _lmsReq(method, path, type, data, callback) {
      this._bareReq(method, path, type, data, function (response) {
        return callback(JSON.parse(response));
      });
    }
  }, {
    key: "lmsPost",
    value: function lmsPost(path, data, callback) {
      this._lmsReq('POST', path, 'application/json', JSON.stringify(data), callback);
    }
  }, {
    key: "lmsGet",
    value: function lmsGet(path, callback) {
      this._lmsReq('GET', path, null, null, callback);
    }
  }, {
    key: "htmlGet",
    value: function htmlGet(path, callback) {
      this._bareReq('GET', path, null, null, callback);
    }
  }, {
    key: "reloadActivityBody",
    value: function reloadActivityBody() {
      var _this4 = this;

      Activity.ready(function () {
        if (_this4.gotActivityBody) {
          _this4._gettingActivityBody = _this4.gotActivityBody = false;

          _this4.loadActivityBody();
        }
      });
    }
  }, {
    key: "loadActivityBody",
    value: function loadActivityBody() {
      var _this5 = this;

      Activity.ready(function () {
        if (_this5._gettingActivityBody) return;
        if (_this5.dispatchEvent(_this5._event('loadActivityBody', true)) == false) return;
        _this5._gettingActivityBody = true;

        _this5.getContentForActivity(_this5.$().data('thisActivityLink'), 'activity-body', _this5._readOnly ? {
          readOnly: 1
        } : null).then(function (rv) {
          _this5.gotActivityBody = true;

          var b = _this5.$('.activity-body').attr('style');

          _this5.$('.activity-body').remove();

          _this5.$().append(rv);

          _this5.$('.activity-body').attr('style', b);

          _this5.dispatchEvent(_this5._event('loadedActivityBody'));
        });
      });
    }
  }, {
    key: "useExistingActivity",
    value: function useExistingActivity() {
      this._tempUsingExistingActivity = true;
    }
  }, {
    key: "getContentForActivity",
    value: function getContentForActivity(activityUrl) {
      var _this6 = this;

      var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'activity';
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      return new _promisePolyfill.default(function (resolve) {
        var p = activityUrl.split('?');
        var q = (p[1] || '').split('&');
        var o = {};
        q.map(function (v) {
          return v.split('=');
        }).map(function (v) {
          return [decodeURIComponent(v[0]), decodeURIComponent(v.slice(1).join('='))];
        }).forEach(function (_ref4) {
          var _ref5 = babelHelpers.slicedToArray(_ref4, 2),
              key = _ref5[0],
              value = _ref5[1];

          return o[key] = value;
        });
        if (options) Object.assign(o, options);
        o._ = Date.now();
        var tgt = "".concat(p[0], "/").concat(mode);
        var qs = Object.keys(o).map(function (v) {
          return "".concat(encodeURIComponent(v), "=").concat(encodeURIComponent(o[v]));
        }).join('&');
        if (qs) tgt += "?".concat(qs);

        _this6.htmlGet(tgt, function (rv) {
          resolve(rv);
        });
      });
    }
  }, {
    key: "doRestartActivity",
    value: function doRestartActivity() {
      this.doSpecificActivity(this.$().data('thisActivityLink'), 'restart');
    }
  }, {
    key: "doNextActivity",
    value: function doNextActivity() {
      if (this.courseCompleteNotificationId) {
        _Listener.default.showNotificationOverlay(this.courseCompleteNotificationId);

        _SiteLayout.default.current.navigate(this.$().data('endCourseLink')); // + (this.courseCompleteNotificationId ? `#notification=${this.courseCompleteNotificationId}` : '')


        return;
      }

      var next = this.$().data('nextActivityLink');

      if (next) {
        this.doSpecificActivity(next);
      } else {
        if (this.courseCompleteNotificationId) {
          _Listener.default.showNotificationOverlay(this.courseCompleteNotificationId);
        }

        _SiteLayout.default.current.navigate(this.$().data('endCourseLink'));
      }
    }
  }, {
    key: "doPreviousActivity",
    value: function doPreviousActivity() {
      var prev = this.$().data('previousActivityLink');

      if (prev) {
        this.doSpecificActivity(prev);
      } else {
        _SiteLayout.default.current.navigate(this.$().data('detailLink'));
      }
    }
  }, {
    key: "doSpecificActivity",
    value: function doSpecificActivity(url) {
      var _this7 = this;

      var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'activity';

      if (url) {
        this.getContentForActivity(url, mode).then(function (rv) {
          _this7.trigger('unload');

          _this7.$().parent().html(rv);

          return;
        });
      } else {
        _SiteLayout.default.current.navigate(this.$().data('detailLink'));
      }
    }
  }, {
    key: "restartActivity",
    value: function restartActivity(callback) {
      var _this8 = this;

      Activity.ready(function () {
        if (!_this8.dispatchEvent(_this8._event('restartActivity', true))) return;

        _this8.lmsPost("lms/restartActivity/".concat(_this8._courseID, "/").concat(_this8._activityID), {}, function (rv) {
          if (rv.success) {
            _this8.dispatchEvent(_this8._event('restartingActivity'));

            callback = callback || function () {
              return _this8.doRestartActivity();
            };

            setTimeout(callback, 0);
          } else {
            _this8.dispatchEvent(_this8._event('errorRestartingActivity'));
          }
        });
      });
    }
  }, {
    key: "startActivity",
    value: function startActivity(useExisting) {
      var _this9 = this;

      Activity.ready(function () {
        if (_this9._activityDetail) {
          _this9.dispatchEvent(_this9._event('startedActivity', false, {
            activity: _this9._activityDetail
          }));

          $(document).trigger('scroll.activity');
          return;
        }

        if (_this9._gettingActivityDetail) return;
        _this9._tempUsingExistingActivity = useExisting || false;
        if (_this9.dispatchEvent(_this9._event('startActivity', true)) === false) return;
        useExisting = _this9._tempUsingExistingActivity;
        delete _this9._tempUsingExistingActivity;
        _this9._gettingActivityDetail = true;

        _this9.lmsPost("lms/startActivity/".concat(_this9._courseID, "/").concat(_this9._activityID).concat(useExisting ? '?existing=true' : ''), {}, function (rv) {
          _this9._activityDetail = rv;

          _this9.dispatchEvent(_this9._event('startedActivity', false, {
            activity: rv
          }));

          $(document).trigger('scroll.activity');
        });
      });
    }
  }, {
    key: "endActivity",
    value: function endActivity(data) {
      var _this10 = this;

      Activity.ready(function () {
        if (!_this10._activityDetail) return;

        if (_this10._endActivityState) {
          _this10.dispatchEvent(_this10._event('endedActivity', false, {
            activity: _this10._activityDetail,
            endActivityState: _this10._endActivityState
          }));

          return;
        }

        if (_this10._isEndingActivity) return;
        _this10._isEndingActivity = true;

        _this10.lmsPost("lms/endActivity/".concat(_this10._courseID, "/").concat(_this10._activityID), data || {}, function (rv) {
          if (rv.activityComplete) {
            _this10._endActivityState = rv.activityComplete;

            _this10.dispatchEvent(_this10._event('endedActivity', false, {
              activity: _this10._activityDetail,
              endActivityState: rv.activityComplete
            }));
          } else {
            _this10._isEndingActivity = false;
          }

          if (rv.assignment) {
            if (_this10._assignmentState && _this10._assignmentState.id == rv.assignment.id) {
              return;
            }

            _this10._assignmentState = rv.assignment;

            _this10.dispatchEvent(_this10._event('startAssignment', false, {
              activity: _this10._activityDetail,
              assignment: rv.assignment
            }));
          }
        });
      });
    }
  }, {
    key: "_timerFormat",
    value: function _timerFormat(s) {
      if (s > 0) {
        var minutes = Math.floor(s / 60),
            seconds = s % 60;
        return [minutes, "00".concat(seconds).substr(-2)].join(':');
      }

      return '0:00';
    }
  }, {
    key: "_timerRun",
    value: function _timerRun() {
      if (this._timerInterval) clearInterval(this._timerInterval);
      this._timerInterval = setInterval(this._timerTick, 1000);

      this._timerTick();
    }
  }, {
    key: "_timerTick",
    value: function _timerTick() {
      var n = Date.now(),
          od = this._timerDuration;
      this._timerDuration = Math.max(0, this._timerDuration - (n - (this._timerLastTick || n)));
      this._timerLastTick = n;
      var ntp = (50 + this._timerLastTick) % 1000,
          self = this;

      if (!this._timerDuration) {
        clearInterval(this._timerInterval);
      }

      if (!this._timerHidden) {
        if (!this.$('.navbar-fwd.timer').length) {
          this.$('.navbar-fwd').addClass('timer').append("\n\t\t\t\t\t<span class='timer-time'></span>\n\t\t\t\t\t<span class='timer-pie'></span>\n\t\t\t\t");

          if (_compat.default.cssVariables) {
            //	style='--scalable-unit: calc(1px * var(--scalable-base-font-size))'></span>
            // Change this to an exact number of pixels...
            var unit = window.getComputedStyle(this.$('.navbar-fwd .timer-pie')[0]).getPropertyValue('--scalable-unit');
            var sz = unit * 2.25; // 36 / 16

            sz = Math.floor(sz);
            sz /= 36 / 16;
            this.$('.navbar-fwd .timer-pie')[0].setPropertyValue('--scalable-unit', "".concat(sz, "px"));
          }
        }

        this.$('.navbar-fwd .timer-time').text(this._timerFormat(Math.round(this._timerDuration / 1000)));
        var p = this._timerDuration / this._timerInitialDuration;
        (0, _pie.pie)(this.$('.navbar-fwd .timer-pie')[0], {
          percent: Math.round(100 * p),
          pieLength: 0,
          noCheck: true,
          stroke: 'transparent',
          strokeWidth: 4,
          margin: 4,
          fill: '#f8f8f8',
          minPct: 0,
          baseImagePath: "/admin/platform/plugins/".concat(_corePlugin.default, "/resources/images/pie-dark.png"),
          pieDirection: -1
        });
      }

      if (this._timerRunning) {
        if (!this._timerDuration) {
          this.dispatchEvent(this._event('timerExpired'));
        } else {
          this.dispatchEvent(this._event('timerTick'));
        }
      }
    }
  }, {
    key: "hideTimer",
    value: function hideTimer() {
      this._timerHidden = true;
      this.$('.navbar-fwd.timer').empty().removeClass('timer');
    }
  }, {
    key: "clearPosition",
    value: function clearPosition() {
      this.$('.activity-title + .position').remove();
    }
  }, {
    key: "setPosition",
    value: function setPosition(current, total) {
      this.clearPosition();
      this.$('.activity-title').after("<div class='position' data-item-index='".concat(current, "' data-item-count='").concat(total, "'></div>"));
    }
  }, {
    key: "startTimer",
    value: function startTimer(duration) {
      var hidden = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (this._isEditing) return;
      this._timerRunning = true;

      if (duration !== void 0) {
        this._timerDuration = duration;
        this._timerInitialDuration = duration;
        this._timerHidden = hidden;
      }

      if (this._timerInterval) clearInterval(this._timerInterval);
      var tickPeriod = Math.min(1000, duration / 113);

      if (tickPeriod < 1000) {
        var tt = 1000 / tickPeriod;
        tt = Math.round(tt);
        tickPeriod = 1000 / tt;
      }

      this._tickPeriod = tickPeriod;
      this._timerInterval = setInterval(this._timerTick, tickPeriod);

      this._timerTick();
    }
  }, {
    key: "stopTimer",
    value: function stopTimer() {
      clearTimeout(this._timerInterval);
      var tr = this._timerRunning;
      this._timerRunning = false;
      if (tr) this._timerTick();
    }
  }, {
    key: "activityComplete",
    value: function activityComplete() {
      var _this11 = this;

      Activity.ready(function () {
        if (_this11._isEditing) return;

        var r = _this11.dispatchEvent(_this11._event('activityComplete', true, {
          courseComplete: _this11.endActivityState.completedCourse
        }));

        if (_this11._assignmentState) _this11._startAssignment();
        $(document).trigger('scroll.activity');
        if (_this11.endActivityState.restartActivity || !r) return;

        _this11.showNextActivityButton(_this11.endActivityState.completedCourse, _this11.endActivityState.restartActivity, _this11.endActivityState.buttonTitle || 'Next');
      });
    }
  }, {
    key: "$",
    value: function (_$) {
      function $() {
        return _$.apply(this, arguments);
      }

      $.toString = function () {
        return _$.toString();
      };

      return $;
    }(function () {
      var Q = $(this._rootNode);
      if (arguments.length) return Q.find.apply(Q, arguments);
      return Q;
    })
  }, {
    key: "on",
    value: function on() {
      var _$2;

      (_$2 = $(this)).on.apply(_$2, arguments);

      return this;
    }
  }, {
    key: "one",
    value: function one() {
      var _$3;

      (_$3 = $(this)).one.apply(_$3, arguments);

      return this;
    }
  }, {
    key: "off",
    value: function off() {
      var _$4;

      (_$4 = $(this)).off.apply(_$4, arguments);

      return this;
    }
  }, {
    key: "trigger",
    value: function trigger(name) {
      if (babelHelpers.typeof(name) == 'object' && name) {
        var o = {};
        Object.getOwnPropertyNames(name).filter(function (v) {
          return v != 'type';
        }).forEach(function (v) {
          return Object.defineProperty(o, v, Object.getOwnPropertyDescriptor(name, v));
        });
        return this.dispatchEvent(this._event(name.type, true, o));
      } else {
        return this.dispatchEvent(this._event(name, true));
      }
    }
  }, {
    key: "showReviewLink",
    value: function showReviewLink(label, callback) {
      var _this12 = this;

      if (this.$('.finished-banner').length == 0) {
        this.one('showFinishedBanner', function () {
          setTimeout(function () {
            return _this12.showReviewLink(label, callback);
          }, 1);
        });
        return;
      }

      var p = this.$('.activity-subheader .finished-banner');
      p.append("\n\t\t\t<div class='review-link center-block'>\n\t\t\t\t<a href='javascript:void(0)' id='review-content' data-spin='true'>".concat(label, "</a>\n\t\t\t</div>\n\t\t"));
      p.find('#review-content').on('click', function () {
        if (callback) {
          callback.call(_this12);
        } else _this12.restartActivity(function () {
          return _this12.doPreviousActivity();
        });
      });
    }
  }, {
    key: "showTryAgainButton",
    value: function showTryAgainButton(label, callback) {
      var _this13 = this;

      if (this.$('.finished-banner').length == 0) {
        this.one('showFinishedBanner', function () {
          setTimeout(function () {
            return _this13.showTryAgainButton(label, callback);
          }, 1);
        });
        return;
      }

      var p = this.$('.activity-subheader .finished-banner');
      var t = "\n\t\t\t<div class='again-button center-block'>\n\t\t\t\t<button class='btn btn-primary' type='button' id='take-again' data-spin='true'>".concat(label || 'Try Again', "</button>\n\t\t\t</div>\n\t\t");
      if (p.find('.again-button').length) p.find('.again-button').remove();
      if (p.find('.review-link').length) p.find('.review-link').before(t);else p.append(t);
      this.trigger('showingTryAgainButton');
      this.$('#take-again').on('click', function () {
        if (callback) callback.call(_this13);else _this13.restartActivity();
      });

      var b = function b() {
        _this13.$('.again-button').remove();

        _this13.removeEventListener('errorRestartingActivity', b);
      };

      this.addEventListener('errorRestartingActivity', b);
    }
  }, {
    key: "moveButton",
    value: function moveButton() {}
  }, {
    key: "makeButtonHidden",
    value: function makeButtonHidden() {}
  }, {
    key: "makeButtonVisible",
    value: function makeButtonVisible() {}
  }, {
    key: "stopButtonSpin",
    value: function stopButtonSpin() {
      this.$('.btn-activity-button').removeClass('spinning');
    }
  }, {
    key: "showButton",
    value: function showButton(label) {
      var _this14 = this;

      var optId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var wrapperClass = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'activity-button-wrapper';
      var eventName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'buttonClick';
      var parent = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '.activity-body';
      var keepExisting = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
      var optBtnClass = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : "btn-primary";
      parent = '.activity-body';
      var p = this.$(parent);

      if (!keepExisting || p.find('.activity-action-button').length == 0) {
        p.find('.activity-action-button').remove();
        p.append("\n\t\t\t\t<div class='activity-action-button ".concat(wrapperClass, " center-block'>\n\t\t\t\t\t<a href='javascript:void(0)' class='btn ").concat(optBtnClass, " btn-activity-button' ").concat(optId ? "id=\"".concat(optId, "\"") : '', " data-spin='true'></a>\n\t\t\t\t</div>\n\t\t\t"));
      } else {
        p.find('.activity-action-button').append("\n\t\t\t\t<a href='javascript:void(0)' class='btn ".concat(optBtnClass, " btn-activity-button' ").concat(optId ? "id=\"".concat(optId, "\"") : '', " data-spin='true'></a>\n\t\t\t"));
      }

      p.find('.activity-action-button .btn-activity-button:last').text(label).on('click', function (event) {
        if (_this14.dispatchEvent(_this14._event(eventName, true)) == false) {
          event.preventDefault();
        }
      });
    }
  }, {
    key: "showNextActivityButton",
    value: function showNextActivityButton(isEndCourse, isRestart, buttonTitle) {
      var _this15 = this;

      if (this.$('.navbar-fwd.next-activity-button').length == 0) {
        var f = this.$('.navbar-fwd');
        f.after("\n\t\t\t\t<a class='navbar-fwd next-activity-button' data-spin='true' href='javascript:void(0)'>\n\t\t\t\t\t<span></span>\n\t\t\t\t</a>\n\t\t\t");
        setTimeout(function () {
          f.addClass('leave');
          f.next('.navbar-fwd').addClass('enter');
          setTimeout(function () {
            return f.remove();
          }, 1000);
        }, 0);
      }

      this.$('.navbar-fwd').off('click').on('click', function (_ref6) {
        var target = _ref6.currentTarget;
        $(target).addClass('spinning');

        if (_this15.courseCompletionNotificationId || isEndCourse) {
          if (_this15.courseCompleteNotificationId) {
            _Listener.default.showNotificationOverlay(_this15.courseCompleteNotificationId);
          }

          _SiteLayout.default.current.navigate(_this15.$().data('endCourseLink'));
        } else if (isRestart) _this15.doRestartActivity();else _this15.doNextActivity();

        return false;
      });
      this.$('.navbar-fwd.next-activity-button span').text(buttonTitle);
    }
  }, {
    key: "showStartActivityButton",
    value: function showStartActivityButton() {
      var optId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'start-activity-button';
      this.showButton(this.startButtonLabel, optId, 'start-activity-button-wrapper', 'startActivityButtonClick', '.media-object.header-image');
    }
  }, {
    key: "showActivityTitle",
    value: function showActivityTitle() {
      if (!this.$('.activity-body').length) return;
      var x = this.$('.activity-body');
      x.find('> .activity-title').remove();

      if (this._isEditing) {
        x.prepend("<input class=\"activity-title\" data-editable-field-parent=\"title\">");
        x.find('> .activity-title').val(this.$().data('activityTitle'));
      } else {
        x.prepend("<h1 class=\"activity-title\" data-editable-field-parent=\"title\"></h1>");
        x.find('> .activity-title').text(this.$().data('activityTitle'));
      }
    }
  }, {
    key: "updateGlobalResize",
    value: function updateGlobalResize(constraint) {
      if (this._globalResize) {
        this.setupGlobalResize(this._globalResize.type, constraint, this._globalResize.overrideItemSize, this._globalResize.runOnce);
      }
    }
  }, {
    key: "setupGlobalResize",
    value: function setupGlobalResize(type, constraint, overrideItemSize, runOnce) {
      var _this16 = this;

      if (this._globalResize) {
        var evtType = this._globalResize.type.replace(/[^a-z0-9A-Z]/g, '_');

        this.$(this._globalResize.type).each(function () {
          if ($(this).parent().is('.resizeContainer')) {
            var p = this.parentNode;
            p.parentNode.insertBefore(this, p);
            p.parentNode.removeChild(p);
          }

          $(this).removeAttr('width height').css({
            minHeight: '',
            maxHeight: '',
            height: '',
            width: '',
            minWidth: '',
            maxWidth: ''
          });
        });
        $(window).off("resize.activity.".concat(evtType));
      }

      this._globalResize = {
        type: type,
        constraint: constraint,
        overrideItemSize: overrideItemSize,
        runOnce: runOnce
      };
      setTimeout(function () {
        _this16.dispatchEvent(_this16._event('setupGlobalResize', true, {
          objectConstraint: constraint
        }));

        _this16.setupResize(type, constraint, overrideItemSize, runOnce);
      }, 0);
    }
  }, {
    key: "setupResize",
    value: function setupResize(type, constraint, overrideItemSize, runOnce) {
      var _this17 = this;

      var evtType = type.replace(/[^a-zA-Z0-9]/g, '_');
      var inputConstraint = constraint;

      if (inputConstraint && inputConstraint.initial) {
        if (inputConstraint.initial.clientSourceImage) {
          if (!inputConstraint.initial.clientSourceImageObject) {
            inputConstraint.initial.ready = false;
            inputConstraint.initial.clientSourceImageObject = new Image();
            var self = this;

            inputConstraint.initial.clientSourceImageObject.onload = function () {
              inputConstraint.initial.ready = true;
              inputConstraint.initial.width = inputConstraint.initial.clientSourceImageObject.naturalWidth;
              inputConstraint.initial.height = inputConstraint.initial.clientSourceImageObject.naturalHeight;

              _this17.setupResize(type, inputConstraint, overrideItemSize, runOnce);
            };

            inputConstraint.initial.clientSourceImageObject.src = inputConstraint.initial.clientSourceImage;
            return;
          }
        }
      }

      this.$(type).each(function () {
        var n = document.createElement('div');
        n.className = 'resizeContainer';
        this.parentNode.insertBefore(n, this);
        n.appendChild(this);
      });
      $(window).off("resize.activity.".concat(evtType)).on("resize.activity.".concat(evtType), function (event) {
        var items = [].slice.call(_this17.$(type));

        var setupItem = function setupItem(node) {
          var el = $(node);

          if (el.is('img[data-swp-image-info]:not([src])')) {
            var imageInfo = el.data('swpImageInfo');
            var maxWidth = Math.max(window.screen.availWidth || 0, window.screen.width || 0);
            maxWidth = Math.min(maxWidth, imageInfo.width);
            if (maxWidth == 0 || maxWidth == imageInfo.width) el.attr('src', imageInfo.src);else {
              var t = Math.ceil(maxWidth / 200) * 200;
              maxWidth = Math.min(maxWidth, imageInfo.width);
              el.attr('src', "/t/matte=fff0/width=".concat(maxWidth, "/scale/f").concat(imageInfo.src, "/image.").concat(imageInfo.src.split('.').pop()));
              el.parents('.swp-image-wrap').append("\n\t\t\t\t\t\t\t<span class='material-icons' data-icon='share'></span>\n\t\t\t\t\t\t").find('.material-icons').on('click', function (event) {
                window.open(imageInfo.src, '_blank');
              });
            }
          }

          if (el.is('img') && !node.complete) {
            el.on('load', function () {
              constraint = inputConstraint;
              setupItem(node);
            });
            return;
          }

          el.css({
            transition: 'none',
            maxWidth: 'none',
            maxHeight: 'none',
            minWidth: 0,
            minHeight: 0
          });

          if (!el.data('aspectRatio')) {
            var w = node.width,
                h = node.height;

            if (!w || !h) {
              w = el.outerWidth();
              h = el.outerHeight();
            }

            if (constraint && constraint.mdode == 'Custom' && constraint.initial.width && constraint.initial.height) {
              var _constraint$initial = constraint.initial,
                  height = _constraint$initial.h,
                  width = _constraint$initial.w;
            }

            if (el.is('img') && inputConstraint && inputConstraint.noUpscale) {
              var naturalHeight = node.h,
                  naturalWidth = node.w;
            }

            if (overrideItemSize) {
              var height = overrideItemSize.h,
                  width = overrideItemSize.w;
            }

            var ar = h / w;
            el.data({
              width: w,
              height: h,
              aspectRatio: ar
            }).removeAttr('width height').attr('width', 200);
          }

          var parent = el.parents('.media-object');
          el.css({
            width: '',
            height: ''
          }).removeAttr('width height').attr('width', 200);
          var nw = parent.width();
          var nh = nw * el.data('aspectRatio');

          if (el.is('img') && inputConstraint && inputConstraint.noUpscale) {
            constraint = {
              mode: 'Custom',
              initial: {
                width: node.naturalWidth,
                height: node.naturalHeight
              },
              minimum: {
                width: null,
                height: null
              },
              maximum: {
                width: node.naturalWidth,
                height: node.naturalHeight
              }
            };
          } else if (overrideItemSize) {
            constraint = {
              mode: 'Custom',
              initial: overrideItemSize,
              minimum: {
                width: null,
                height: null
              },
              maximum: {
                width: null,
                height: null
              }
            };
          } else {
            constraint = inputConstraint;
          }

          if (constraint) {
            switch (constraint.mode) {
              case 'Column':
                if (el.parents('.resizeContainer').width() != 200) {
                  nw = el.parents('.resizeContainer').width();
                  nh = nw * el.data('.aspectRatio');
                  break;
                }

                break;

              case 'Custom':
                var ow = nw;
                if (constraint.minimum.width && constraint.minimum.width > nw) nw = constraint.minimum.width;
                if (constraint.maximum.width && constraint.maximum.width < nw) nw = constraint.maximum.width;
                if (ow < nw) el.parents('.resizeContainer').css({
                  overflow: 'auto',
                  width: ow,
                  margin: ''
                });else el.parents('.resizeContainer').css({
                  overflow: '',
                  width: nw,
                  margin: '0 auto'
                });
                nh = nw * el.data('aspectRatio');
                break;
            }
          }

          if (el.is('img')) {
            el.removeAttr('width height').css({
              padding: '',
              boxSizing: ''
            });
            var imgWidth = el.prop('width'),
                imgHeight = el.prop('height');
            var imgPaddingV = 0,
                imgPaddingH = 0;
            var th = nw / imgWidth * imgHeight;

            if (th < nh) {
              imgPaddingV = (nh - th) / 2;
              nh = th;
            } else {
              var tw = nh / imgHeight * imgWidth;

              if (tw < nw) {
                imgPaddingH = (nw - tw) / 2;
                nw = tw;
              }
            }

            el.css({
              padding: "".concat(imgPaddingV, "px ").concat(imgPaddingH, "px"),
              boxSizing: 'content-box',
              width: "".concat(nw, "px"),
              height: "".concat(nh, "px")
            }).attr({
              width: nw,
              height: nh
            });
          } else {
            el.removeAttr('width').width(nw).height(nh);
          }

          items.splice(items.indexOf(node), 1);

          if (!items.length) {
            if (runOnce) {
              var t = runOnce;
              runOnce = null;
              t();
            }
          }
        };

        items.forEach(setupItem);

        if (!items.length) {
          if (runOnce) {
            var t = runOnce();
            runOnce = null;
            t();
          }
        }
      });
      setTimeout(function () {
        $(window).trigger("resize.activity.".concat(evtType));
      }, 0);
    }
  }, {
    key: "scrollToTop",
    value: function scrollToTop(animate, targetElement) {
      var top = $(document).scrollTop(),
          hdrHeight = $('#contentHeaderContainer').outerHeight();
      if (targetElement) hdrHeight = this.$(targetElement).eq(0).offset().top - hdrHeight;

      if (top > hdrHeight) {
        if (animate) {
          var p = top - hdrHeight;
          var a = new _animationHelper.default(200, 'ease-in-out', function (percent) {
            var px = pct * p;
            $(document).scrollTop(top - px);
          });
          a.start();
        } else {
          $(document).scrollTop(hdrHeight);
        }
      }
    }
  }, {
    key: "startActivityState",
    get: function get() {
      return this._activityDetail;
    }
  }, {
    key: "assignmentState",
    get: function get() {
      return this._assignmentState;
    }
  }, {
    key: "endActivityState",
    get: function get() {
      return this._endActivityState;
    }
  }, {
    key: "readOnly",
    get: function get() {
      return this._readOnly;
    }
  }], [{
    key: "_addEventListener",
    value: function _addEventListener(target, type, callback) {
      if (!target._events) target._events = {};
      if (!target._events[type]) target._events[type] = [];
      if (target._events[type].filter(function (v) {
        return v == callback;
      }).length) return;

      target._events[type].push(callback);
    }
  }, {
    key: "addEventListener",
    value: function addEventListener(type, callback) {
      Activity._addEventListener(Activity, type, callback);
    }
  }, {
    key: "_removeEventListener",
    value: function _removeEventListener(target, type, callback) {
      if (!target._events) target._events = {};

      if (target._events[type]) {
        target._events[type] = target._events[type].filter(function (v) {
          return v != callback;
        });

        if (!target._events[type].length) {
          delete target._events[type];
        }
      }
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(type, callback) {
      Activity._removeEventListener(Activity, type, callback);
    }
  }, {
    key: "_dispatchEvent",
    value: function _dispatchEvent(target, event) {
      if (event._dispatched) throw new InvalidStateError("Trying to call dispatchEvent() on an already processed ActivityEvent object.");
      var type = event.type;
      event._dispatched = true;
      event.target = event.currentTarget = event.originalTarget = target;
      event.bubbles = false;
      event.isTrusted = false;
      if (!target._events) target._events = {};

      if (target._events[type]) {
        var x = target._events[type];

        for (var i = 0; i < x.length; i++) {
          var f = x[i];

          try {
            var rv = f.call(target, event);
            if (rv === false) event.preventDefault();
          } catch (e) {
            ;
          }

          if (event._stopped == 'now') {
            return event.cancelable ? !event._cancelled : true;
          }
        }
      }

      return event.cancelable ? !event._cancelled : true;
    }
  }, {
    key: "dispatchEvent",
    value: function dispatchEvent(event) {
      return Activity._dispatchEvent(Activity, event);
    }
  }, {
    key: "_event",
    value: function _event(type) {
      var cancelable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var E = new ActivityEvent(type, {
        cancelable: cancelable
      });
      Object.assign(E, props || {});
      return E;
    }
  }, {
    key: "ready",
    value: function ready(fn, self) {
      var _this18 = this;

      if (!fn && !self) {
        return new _promisePolyfill.default(function (resolve) {
          if (_this18._ready) resolve(true);else {
            var fn = function fn() {
              resolve(true);

              _this18.removeEventListener('ready', fn);
            };

            _this18.addEventListener('ready', fn);
          }
        });
      }

      if (this._ready) {
        fn.call(self);
      } else {
        var f = function f() {
          fn.call(self);

          _this18.removeEventListener('ready', f);
        };

        this.addEventListener('ready', f);
      }
    }
  }]);
  return Activity;
}(), _class4._ready = false, _temp2), (babelHelpers.applyDecoratedDescriptor(_class3.prototype, "_courseCompleteNotification", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "_courseCompleteNotification"), _class3.prototype), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "_activityComplete", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "_activityComplete"), _class3.prototype), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "_startedActivity", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "_startedActivity"), _class3.prototype), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "_startAssignment", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "_startAssignment"), _class3.prototype), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "_showingFinishedBanner", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "_showingFinishedBanner"), _class3.prototype), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "_showFinishedBanner", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "_showFinishedBanner"), _class3.prototype), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "_timerTick", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "_timerTick"), _class3.prototype)), _class3);
exports.default = Activity;
Activity.ready(function () {
  return Activity._ready = true;
}); // ---
// Activity page helpers

var bodySizeTimeout;

function fixBodySize() {
  if (bodySizeTimeout) clearTimeout(bodySizeTimeout);
  bodySizeTimeout = setTimeout(function () {
    if ($('.activity-body').length) {
      var hh = $(window).height();

      if ($('.activity-header').css('display') != 'none') {
        hh -= $('.activity-header').height();
      }

      hh = "".concat(hh, "px");
      if ($('.activity-body').css('minHeight') != hh) $('.activity-body').css('minHeight', hh);
    }
  }, 16);
}

function activityReady() {
  $(window).off('resize.fixBody').on('resize.fixBody', fixBodySize);

  try {
    var obs = new MutationObserver(fixBodySize);
    obs.observe(document.querySelector('.activity'), {
      childList: true,
      attributes: true,
      characterData: true,
      subtree: true
    });
  } catch (e) {
    setInterval(fixBodySize, 1000);
  }

  $(document).off('scroll.activity').on('scroll.activity', scrollHandler);
  var hdrHeight = $('#contentHeaderContainer').outerHeight();
  $('#headerContainerInner').css({
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0
  });
  var t = 0;

  if (!/\/activity?\?/.test(document.referer) & !window.activityAlreadyLoaded) {
    t = 2000;
    window.activityAlreadyLoaded = true;
  }

  var A = new _animationHelper.default(t, 'ease-in-out', function (percent) {
    $(document).scrollTop(percent * hdrHeight);
  });
  A.start();
  Activity.dispatchEvent(Activity._event('ready'));
}

function scrollHandler() {
  var top = $(document).scrollTop(),
      hdrHeight = $('#contentHeaderContainer').outerHeight();
  top = Math.min(top, hdrHeight);
  var ntop = 0 - top;
  var transformUp = {
    '-ms-transform': "translate(0px, ".concat(ntop, "px)"),
    '-webkit-transform': "translate(0px, ".concat(ntop, "px)"),
    '-moz-transform': "translate(0px, ".concat(ntop, "px)"),
    transform: "translate(0px, ".concat(ntop, "px)")
  };
  var positionUp = {
    top: "".concat(ntop, "px")
  };
  var marginUp = {
    'margin-top': "".concat(ntop, "px")
  };
  $('#sidebar .nav-tabs').css({
    top: ntop == 0 ? 0 : 0 - hdrHeight
  });
  $('#headerContainerInner').css(transformUp);
  if ($('body').is('.trident')) $('#headerBgPlacement').css(transformUp);
  $('#contentHeaderContainer').css({
    zIndex: 1,
    height: "".concat(hdrHeight, "px"),
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0
  });
  $('.activity[data-activity-root] .activity-header').css('margin-top', "".concat(hdrHeight, "px"));

  if (top == hdrHeight) {
    var cc = $('#contentContainer')[0];
    $('.activity[data-activity-root] .activity-header').parent().css({
      paddingTop: "".concat($('.activity[data-activity-root] .activity-header').height() + hdrHeight, "px")
    });
    var zp = 3;
    if ($('.activity[data-activity-root] .interstitial').length) zp = 1050;
    $('.activity[data-activity-root] .activity-header').css({
      position: 'fixed',
      top: 0,
      left: 0,
      right: cc.offsetWidth - cc.clientWidth,
      marginTop: 0,
      zIndex: zp
    });
  } else {
    $('.activity[data-activity-root] .activity-header').parent().css({
      paddingTop: ''
    });
    $('.activity[data-activity-root] .activity-header').css({
      position: 'relative',
      top: '',
      left: '',
      right: '',
      background: '',
      marginTop: "".concat(hdrHeight, "px"),
      zIndex: ''
    });
  }

  $('#contentContainerRow').css('background', $('#mainContentContainer').css('background'));
}

function setupActivityPage(node) {
  var readOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  $(activityReady);
  ['activity', 'endActivityState', 'remaining', 'courseComplete', 'objectConstraint', 'propertyName', 'propertyValue'].forEach($.event.addProp);
  var parent = node.parentNode;
  var forEditor = $(parent).data('editor');
  var state = $(parent).data('state'),
      type = $(parent).data('activityType');

  var activity = require("activity/".concat(type)).default;

  $(parent).data('activity', new activity(parent, readOnly, state, forEditor));

  if (forEditor) {
    var A = $(parent).data('activity');
    A.addEventListener('updateField', function (event) {
      if (event.propertyName == 'title') {
        A.$().data('activityTitle', event.propertyValue);
        A.$('.activity-title').val(event.propertyValue);
      } else if (event.propertyName == 'showTitle') {
        var v = JSON.stringify(event.propertyValue);
        A.$().data('activityShowTitle', v);
        A.$().attr('data-activity-show-title', v);
      } else if (event.propertyName == 'enableDescription') {
        var v = JSON.stringify(event.propertyValue);
        A.$().data('activityShowDescription', v);
        A.$().attr('data-activity-show-description', v);
      }
    });
  }
}

function setupActivityElement(element) {
  var activity = $(element).parents('.activity').data('activity');
  activity.$('.modal').modal({
    show: false
  });
  activity.$('.modal').data('bs.modal').isShown = true;
  activity.$('.modal').data('bs.modal').$backdrop = activity.$('.modal-wrapper .modal-backdrop');
  activity.$('#start-activity-button').on('click', function () {
    activity.startActivity();
  });
  activity.addEventListener('startActivity', function (event) {
    if (this.gotActivityBody) {
      return;
    }

    event.stopImmediatePropagation();
    event.preventDefault();
    $('#start-activity-button').off('click').prop('disabled', true).addClass('spinning');
    activity.setupForStart = true;
    activity.loadActivityBody();
  });
  activity.addEventListener('loadedActivityBody', function (event) {
    activity.startActivity();
  });
  activity.addEventListener('startedActivity', function (event) {
    activity.$('.interstitial .modal').on('hidden.bs.modal', function () {
      activity.$('.interstitial').remove();
      activity.$('.activity-body').css({
        marginTop: '',
        maxHeight: '',
        overflow: '',
        paddingBottom: ''
      });
      $(window).off('resize.interstitial');
      activity.$().off('load.interstitial');
    }).modal('hide');
  });
  $(window).on('resize.interstitial', function () {
    var e = activity.$('.interstitial');
    var ah = e.parent().children('.activity-header');
    var ahh = ah.outerHeight();
    var h = $(window).height() - ahh;
    console.log(h);
    e.css('min-height', h);
    e.find('.modal-body').css('margin-top', 0 - ahh);
    e.find('.modal-body').css('padding', ahh + 'px 0px');
  }).triggerHandler('resize');
  activity.$().on('load.interstitial', function () {
    $(window).triggerHandler('resize');
  });
  $(function () {
    $(window).triggerHandler('resize');
  });
}

function setupImageWrapStub(image, id) {
  var img = new Image();

  img.onload = function () {
    $("#".concat(id)).removeClass('swp-image-wrap-stub').addClass('swp-image-wrap');
    $("#".concat(id)).html("<div class='resizeContainer'><img></div>");
    $("#".concat(id, " img")).attr("data-swp-image-info", JSON.stringify({
      src: image,
      width: img.naturalWidth,
      height: img.naturalHeight
    }));
    $(window).resize();
  };

  img.src = image;
}

function setupActivityInfoModal(element) {
  var activity = $(element).parents('.activity').data('activity');
  activity.$('.modal#activity-info').modal({
    show: false
  });
  activity.$('.modal#activity-info #start-activity-button').on('click', function () {
    activity.$('.modal#activity-info').modal('hide');
  });
  activity.$('.modal#activity-info').on('hidden.bs.modal', function () {
    activity.$('.info-modal').css('height', '');
    $(window).off('resize.info-modal');
    activity.$().off('load.info-modal');
  }).on('show.bs.modal', function () {
    $(window).on('resize.info-modal', function () {
      var e = activity.$('.info-modal');
      var ah = e.parent().children('.activity-header');
      var ahh = ah.outerHeight();
      var h = $(window).height() - ahh;
      e.css('height', h);
      e.find('.modal-body').css({
        'margin-top': 0 - ahh,
        'padding': "".concat(ahh, "px 0px")
      });
    }).triggerHandler('resize');
    activity.$().on('load.info-modal', function () {
      $(window).triggerHandler('resize');
    });
  });
}